import VueMq from 'vue-mq';
import VueMoment from 'vue-moment';
import VueClipboard from 'vue-clipboard2';
import VueConfetti from 'vue-confetti';
import VueGtag from 'vue-gtag';

import moment from 'moment-timezone';
import VueCookies from 'vue-cookies';
import VueProgressBar from 'vue-progressbar';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import Vue from 'vue';
import GAuth from 'vue-google-oauth2';
import App from './App.vue';
import router from './router';
import store from './store';
// import { i18n } from './lang/i18n-setup';
import i18n from './lang/i18n-setup';
import './plugins/element';
import 'vue-swipe-actions/dist/vue-swipe-actions.css';

Vue.use(VueMoment, {
  moment,
});

Vue.use(VueConfetti);

Vue.use(
  VueGtag,
  {
    config: { id: process.env.VUE_APP_GA },
  },
  router,
);

Vue.use(VueCookies);

Vue.use(VueMq, {
  breakpoints: {
    mobile: 450,
    tablet: 900,
    laptop: 1250,
    desktop: Infinity,
  },
});

Vue.use(VueClipboard);

Vue.use(VueProgressBar, {
  thickness: '4px',
});

Vue.config.productionTip = false;

// force devtools usage on staging
if (process.env.VUE_APP_ENV === 'staging') {
  Vue.config.devtools = true;
}

if (process.env.VUE_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    environment: process.env.VUE_APP_ENV,
    integrations: [new Integrations.Vue({
      Vue,
      attachProps: true,
      logErrors: process.env.VUE_APP_ENV === 'dev',
    })],
    ignoreErrors: [
      'ResizeObserver loop limit exceeded', // This error means that ResizeObserver was not able to deliver all observations within a single animation frame. It is benign
      'network error', // Backend doesn't send response, front-end cannot do anything about it. handled by axios client
      'The network connection was lost.', // SSE error, it automatically reconnect after this error is thrown so no need to log
      'No activity within 45000 milliseconds. Reconnecting.', // SSE error, it automatically reconnect after this error is thrown so no need to log
      'TypeError: The expression cannot be converted to return the specified type.', // SSE error only on firefox. Doesn't break anything
    ],
  });
}

const gauthOption = {
  clientId: '1055102614912-lro1lsudga9dg8oa18mcjn8bt6s0ksmu.apps.googleusercontent.com',
  scope: 'https://www.googleapis.com/auth/calendar.events',
  prompt: 'consent',
};
Vue.use(GAuth, gauthOption);

Vue.prototype.$EventBus = new Vue();

new Vue({
  router,
  store,
  i18n,
  watch: {
    $route: () => {
      if (window.Appcues) window.Appcues.page();
    },
  },
  render: (h) => h(App),
}).$mount('#app');
